<div class="alertbox error">
    <div class="icon">
        <img src="../../../../assets/img/icon/error.png" alt="Error">
    </div>
    <h4>404</h4>
    <p><b>{{ "Oops, an error has occurred. Page not found!" | translate }}</b></p>
</div>